export const PARKING_LOT_PREFIX_STRING = 'park+'

export const PARKING_LOT_PREFIX_DIGITS = '59'

export const PRESENCE_SUBSCRIPTION_REFRESH_INTERVAL = 120000
